import { Component, OnInit } from '@angular/core';
import { NumericTraitInfo, TraitCondition } from '../../trait.reference.model';
import { MultiTraitQueryContext } from '../../multi-trait-query-context';
import { AlertService } from '../../../shared/alert/alert.service';
import { TraitFilterContext } from '../trait-filter-context';
import { TranslateService } from '@ngx-translate/core';
import { Weight } from '../../../shared/query/model/weight.model';

@Component({
    selector: 'jhi-number-traits-pane',
    templateUrl: 'number-traits-pane.component.html'
})
export class NumberTraitsPaneComponent implements OnInit {
    conditionOptions = [
        { label: 'multi-trait-query.condition.categorical.drop-trait', value: TraitCondition.DROP_TRAIT },
        { label: 'multi-trait-query.condition.categorical.keep-all', value: TraitCondition.KEEP_ALL },
        { label: 'multi-trait-query.condition.categorical.less-than', value: TraitCondition.LESS_THAN },
        { label: 'multi-trait-query.condition.categorical.less-than-or-equal', value: TraitCondition.LESS_THAN_EQUAL },
        { label: 'multi-trait-query.condition.categorical.equal', value: TraitCondition.EQUAL },
        { label: 'multi-trait-query.condition.categorical.greater-than-or-equal', value: TraitCondition.GREATER_THAN_EQUAL },
        { label: 'multi-trait-query.condition.categorical.greater-than', value: TraitCondition.GREATER_THAN },
        { label: 'multi-trait-query.condition.categorical.between', value: TraitCondition.BETWEEN },
        { label: 'multi-trait-query.condition.categorical.in', value: TraitCondition.IN },
        { label: 'multi-trait-query.condition.categorical.not.in', value: TraitCondition.NOT_IN }
    ];
    traitWeightOptions = [
        { label: 'multi-trait-query.environment.weight.important', value: Weight.IMPORTANT },
        { label: 'multi-trait-query.environment.weight.critical', value: Weight.CRITICAL },
        { label: 'multi-trait-query.environment.weight.desirable', value: Weight.DESIRABLE },
        { label: 'multi-trait-query.environment.weight.ignored', value: Weight.IGNORED }
    ];
    validationError: string;
    protected readonly TraitCondition = TraitCondition;

    constructor(private alertService: AlertService,
                public traitFilterContext: TraitFilterContext,
                public queryContext: MultiTraitQueryContext,
                private translateService: TranslateService) {
    }

    ngOnInit() {
    }

    isLimitsDisabled(numberTrait: NumericTraitInfo): boolean {
        return numberTrait.condition === TraitCondition.DROP_TRAIT ||
            numberTrait.condition === TraitCondition.KEEP_ALL;
    }

    showRoundOff(value: number) {
        return value > 1 ? value.toFixed(1) : value.toFixed(2);
    }

    showMessageError(numberTrait: any) {
        if (numberTrait.limits.trim() === '') {
            return this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.error.limits.empty.value');
        }

        switch (numberTrait.condition) {
        case TraitCondition.IN:
        case TraitCondition.NOT_IN:
        case TraitCondition.BETWEEN:
            return this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.error.limits.invalid.value');
        default:
            return this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.error.limits.exceeded.limits');
        }
    }

    selectedCondition(numberTrait: NumericTraitInfo) {
        if (numberTrait.condition === TraitCondition.DROP_TRAIT) {
            numberTrait.priority = Weight.IGNORED;
        } else {
            numberTrait.priority = Weight.IMPORTANT;
        }
    }

}
